import { useSelector } from 'react-redux';
import { qualYearSelect } from 'Redux/Selectors/Contracts.Globals.Selectors';

const useQualificationYear = () => {
	const { isLoaded: qualYearLoaded, selected: qualYear } = useSelector(qualYearSelect);
	return { qualYearLoaded, qualYear };
};

export default useQualificationYear;
